import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Tooltip, Row, Col, Spin, Modal, Input } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { useNavigate } from "react-router";
import PRPopUpDetails from "../PR/PRPopUpDetails";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Select } from "antd";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import PRPopUpDetailsForSteel from "../PR/PRPopUpDetailsForSteel";
const { Panel } = Collapse;

const CityWiseVendorSelection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { responseId } = useParams();
  const [totalWbsAmount, setTotalWbsAmount] = useState(null);
  const [siteIdAmount, setSiteIdAmount] = useState([]);
  const [RFQMaterialDetails, setRFQMaterialDetails] = useState(null);
  const [RFQMaterial, setRFQMaterial] = useState([]);
  const [rfqNumber, setRfqNumber] = useState([]);
  const [rendomId, setRendomId] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [state, setState] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [prNumbers, setPrNumbers] = useState([]);
  const [view, setView] = useState(null);
  const [type, setType] = useState("City Wise");
  const [am, setAm] = useState(0);
  const formRef = useRef();
  const [rfqMaterialDetailsID, setRfqMaterialDetailsID] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [uomList, setUOMList] = useState([]);
  const [masterId, setMasterId] = useState(null);
  const [ifMultipleMasterId, setIfMultipleMasterId] = useState([]);
  const [aggregatedData, setAggregateData] = useState(null);
  const [prNumberList, setPRNumberList] = useState([]);
  const [statePRDetailsHover, setStatePRDetailsHover] = useState(null);
  const [prNumberHover, setPRNumberHover] = useState(null);
  const [prCreatorHover, setCreatorHover] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenRfq, setIsModalOpenRfq] = useState(false);
  const [prNumberd, setPrNumberd] = useState(null);
  const [categoryId, setCategoryId] = useState(1);
  const [pincodeList, setPincodeList] = useState([]);
  const { Option } = Select;
  const [diameterList, setDiameterList] = useState([]);
  const [cityLength, setCityLength] = useState(0);
  const [originalData, setOriginalData] = useState([]);

  const getAllDiameters = (response) => {
    const allDiameters = new Set();
    response?.forEach((cityObj) => {
      cityObj.city_wise_pr.forEach((city) => {
        city.site_wise_details.forEach((site) => {
          site.material_wise_details.forEach((material) => {
            material.diameter_wise?.forEach((dia) => {
              allDiameters.add(dia.diameter_name.replace(".00 mm", " MM"));
            });
          });
        });
      });
    });
    return Array.from(allDiameters).sort((a, b) => {
      const numA = parseFloat(a);
      const numB = parseFloat(b);
      return numA - numB;
    });
  };

  useEffect(() => {
    fetchRFQMaterialDetails();
    getCurrency();
  }, []);

  useEffect(() => {
    if (categoryId) {
      getUnitOfMeasurement();
    }
  }, [categoryId]);

  const updateTableData = (state) => {
    if (!Array.isArray(state)) {
      return;
    }
    const newTableData = [];
    let srNoCounter = 1;
    let lastCityName = null;
    let lastSiteName = null;
    const uniqueMasterIdsBySiteAndMaterial = {};
    state?.forEach((prObject) => {
      prObject.city_wise_pr?.forEach((city) => {
        city.site_wise_details?.forEach((site) => {
          const siteName = site.site_name;
          if (!uniqueMasterIdsBySiteAndMaterial[siteName]) {
            uniqueMasterIdsBySiteAndMaterial[siteName] = {};
          }
          site.material_wise_details?.forEach((material) => {
            const materialTypeName = material.material_type_name;
            if (!uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName]) {
              uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName] =
                new Set();
            }
            if (material.purchase_requisition_master_id) {
              uniqueMasterIdsBySiteAndMaterial[siteName][materialTypeName].add(
                material.purchase_requisition_master_id
              );
            }
          });
        });
      });
    });

    state.forEach((prObject, prIndex) => {
      const cityWisePr = prObject.city_wise_pr || [];

      cityWisePr.forEach((city, cityIndex) => {
        let cityTotalAmount = 0;
        let isFirstRowOfCity = true;
        lastSiteName = null;

        city.site_wise_details.forEach((site, siteIndex) => {
          let siteMaterialTotalAmount = 0;
          let isFirstRowOfSite = true;
          lastSiteName = site.site_name;
          const seenSubCategories = new Set();

          const materialGroups = site.material_wise_details.reduce(
            (acc, material) => {
              const materialTypeName = material.material_type_name;
              if (!acc[materialTypeName]) {
                acc[materialTypeName] = {
                  ...material,
                  pr_total_quantity: 0,
                  pr_total_quantity_by_kg: 0,
                  purchase_requisition_master_ids: new Set(),
                  vendors: [],
                  diameter_wise_map: {},
                  diameter_wise: [],
                  original_uom: material.material_type_uom_name,
                };
              }
              acc[materialTypeName].pr_total_quantity +=
                material.pr_total_quantity;
              acc[materialTypeName].pr_total_quantity_by_kg +=
                material.pr_total_quantity_by_kg;
              if (material.purchase_requisition_master_id) {
                acc[materialTypeName].purchase_requisition_master_ids.add(
                  material.purchase_requisition_master_id
                );
              }
              const existingVendorIds = new Set(
                acc[materialTypeName].vendors.map((v) => v.id)
              );
              (material.vendors || []).forEach((v) => {
                if (!existingVendorIds.has(v.id)) {
                  acc[materialTypeName].vendors.push(v);
                }
              });
              (material.diameter_wise || []).forEach((dia) => {
                const key = dia.diameter_id;
                let qty = dia.quantity;
                // Conversion logic
                const group = acc[materialTypeName];
                const uniqueMasterIdsSet =
                  uniqueMasterIdsBySiteAndMaterial[site.site_name]?.[
                    materialTypeName
                  ] || new Set();
                let preferredUoM = group.material_type_uom_name;
                if (uniqueMasterIdsSet.size > 1) {
                  preferredUoM = group.preferred_unit_of_measurement;
                }
                if (
                  material.material_type_uom_name === "KG" &&
                  preferredUoM === "MT"
                ) {
                  qty = qty / 1000;
                } else if (
                  material.material_type_uom_name === "MT" &&
                  preferredUoM === "KG"
                ) {
                  qty = qty * 1000;
                }
                if (!group.diameter_wise_map[key]) {
                  group.diameter_wise_map[key] = { ...dia, quantity: 0 };
                }
                group.diameter_wise_map[key].quantity += qty;
              });
              return acc;
            },
            {}
          );

          const groupedMaterials = Object.values(materialGroups).map(
            (group) => {
              const siteName = site.site_name;
              const materialTypeName = group.material_type_name;
              const uniqueMasterIdsSet =
                uniqueMasterIdsBySiteAndMaterial[siteName]?.[
                  materialTypeName
                ] || new Set();
              let uom = group.material_type_uom_name;
              let uom_pref = group.preferred_unit_of_measurement_id;
              let unit_measurement = group.material_type_uom;
              let unit_measurement_id = group.material_type_uom;
              let unit_measurement_name = group.material_type_uom_name;
              let diameter_wise = Object.values(group.diameter_wise_map);
              if (uniqueMasterIdsSet.size > 1) {
                uom = group.preferred_unit_of_measurement;
                uom_pref = group.preferred_unit_of_measurement_id;
                unit_measurement = group.preferred_unit_of_measurement_id;
                unit_measurement_id = group.preferred_unit_of_measurement_id;
                unit_measurement_name = group.preferred_unit_of_measurement;
              }
              const diameterWiseAmount = (diameter_wise || []).reduce(
                (total, dia) => {
                  let quantityInKg = dia.quantity;
                  if (uom === "MT") {
                    quantityInKg = dia.quantity * 1000;
                  }
                  return total + quantityInKg * dia.estimated_price;
                },
                0
              );
              const estAmount = diameterWiseAmount;
              siteMaterialTotalAmount += estAmount;
              cityTotalAmount += estAmount;
              const vendorsWithDefaultSelection = (group.vendors || []).map(
                (vendor) => ({
                  ...vendor,
                  is_selected_vendor: group.rfq_material_id
                    ? vendor.is_selected_vendor
                    : true,
                })
              );
              const subCategory = group.material_type_sub_category;
              const showSubCategory = !seenSubCategories.has(subCategory);
              seenSubCategories.add(subCategory);
              const row = {
                key: `${prIndex}-${cityIndex}-${siteIndex}-${materialTypeName}`,
                isMaterialRow: true,
                srNo: isFirstRowOfCity ? srNoCounter++ : undefined,
                cityName: isFirstRowOfCity ? city.city_name : undefined,
                siteName: isFirstRowOfSite ? site.site_name : undefined,
                siteId: site.site_id,
                materialName: group.material_type_name,
                vendors: vendorsWithDefaultSelection,
                remark: group.remark,
                estimatedPrice: group.estimated_material_unit_price,
                quantity_by_kg: group.pr_total_quantity_by_kg,
                uom,
                uom_pref,
                subCategory: showSubCategory ? subCategory : "",
                estAmount: estAmount,
                unit_measurement,
                unit_measurement_id,
                unit_measurement_name,
                purchase_master_ids: Array.from(
                  group.purchase_requisition_master_ids
                ),
                purchase_requisition_material_id:
                  group.purchase_requisition_material_id,
                diameter_wise,
                id: group.rfq_material_id,
                quantity: group.pr_total_quantity,
                rfq_material_idd: group.rfq_material_id,
              };
              isFirstRowOfCity = false;
              isFirstRowOfSite = false;
              return row;
            }
          );

          groupedMaterials.forEach((material) => {
            newTableData.push(material);
          });

          newTableData.push({
            key: `${prIndex}-${cityIndex}-${siteIndex}-subtotal`,
            isSubTotal: true,
            siteName: "Sub Total",
            totalAmount: siteMaterialTotalAmount,
          });
        });

        newTableData.push({
          key: `${prIndex}-${cityIndex}-citytotal`,
          isCityTotal: true,
          siteName: "City Total",
          totalAmount: cityTotalAmount,
        });
      });
    });

    setTableData(newTableData);
    return newTableData;
  };

  const fetchRFQMaterialDetails = async () => {
    setapiLoading(true);
    try {
      const response1 = await getRequest(`float-rfq/${responseId}`);
      const responseData = response1.data.data;

      setOriginalData(responseData.pr_city_wise_by_pr_number);
      setRFQMaterialDetails(responseData);

      if (responseData && responseData.pr_city_wise_by_pr_number) {
        setDiameterList(
          getAllDiameters(responseData.pr_city_wise_by_pr_number)
        );
        updateTableData(responseData.pr_city_wise_by_pr_number);
        setCityLength(
          responseData.pr_city_wise_by_pr_number[0]?.city_wise_pr?.length || 0
        );
      }

      setType("City Wise");

      if (formRef.current) {
        formRef.current.setFieldsValue({
          pr_view: "City Wise",
        });
      }

      setCategoryId(responseData.category_tree);
      setRfqNumber(responseData.rfq_number);
      setPrNumberd(responseData.pr_creator_name);
      setPRNumberList(responseData.purchase_requisition_city_by_pr_number);

      const masterId = responseData.rfq_details[0].id;
      if (masterId) {
        setMasterId(masterId);
      }

      setView("City Wise");

      setRendomId(responseId);
      const prs = responseData?.pr_number?.map((pr) => pr);
      setPrNumbers(prs);

      const initialState = {
        rfqId: responseData.rfq_details[0].id,
        rfq_material_details: responseData.material_wise_details.map(
          (material) => {
            return {
              id: material.rfq_material_id,
              material_total_quantity:
                material.material_total_quantity_by_kg / 1000,
              material_total_quantity_by_kg:
                material.material_total_quantity_by_kg,
              amount: material.amount,
              purchase_requisition_material:
                material.purchase_requisition_material_id,
              purchase_requisition_material_type_name:
                material.purchase_requisition_material_type_name,
              unit_of_measurement: material.unit_of_measurement,
              purchase_requisition_material_type_idd:
                material.purchase_requisition_material_type_id,
            };
          }
        ),
      };
      setState(initialState);

      const rfqMaterialDetails = responseData?.rfq_material_details;

      if (
        Array.isArray(rfqMaterialDetails) &&
        rfqMaterialDetails.length === 0
      ) {
        setRfqMaterialDetailsID(false);
      } else {
        setRfqMaterialDetailsID(true);
      }
      setTotalWbsAmount(responseData.rfq_total_amount);

      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };
  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  const getUnitOfMeasurement = async () => {
    const response = await getRequest(
      `get-category-by-uom/?category_tree=${categoryId}`
    );
    if (response?.data?.results?.data) {
      setPincodeList(response.data.results.data);
    }
  };

  const handleVendorChange = (selectedVendorIds, recordKey) => {
    setTableData((prev) =>
      prev.map((row) => {
        if (row.key === recordKey && row.isMaterialRow) {
          const updatedVendors = row.vendors.map((vendor) => ({
            ...vendor,
            is_selected_vendor: selectedVendorIds.includes(vendor.id),
          }));
          return { ...row, vendors: updatedVendors };
        }
        return row;
      })
    );
  };

  const handleUOMChange = (newUoM, recordKey) => {
    setTableData((prev) =>
      prev.map((row) => {
        if (row.key === recordKey && row.isMaterialRow) {
          const uomObject = pincodeList.find(
            (uom) => uom.unit_of_measurement === newUoM
          );
          const newUomId = uomObject ? uomObject.id : row.unit_measurement;

          let newQuantity = row.quantity;
          let newDiameterWise = row.diameter_wise?.map((d) => {
            let newDiaQty = d.quantity;
            if (newUoM === "MT" && row.uom !== "MT") {
              newDiaQty = d.quantity / 1000;
            } else if (newUoM === "KG" && row.uom !== "KG") {
              newDiaQty = d.quantity * 1000;
            }
            return { ...d, quantity: newDiaQty };
          });
          if (newUoM === "MT" && row.uom !== "MT") {
            newQuantity = row.quantity / 1000;
          } else if (newUoM === "KG" && row.uom !== "KG") {
            newQuantity = row.quantity * 1000;
          }
          return {
            ...row,
            uom: newUoM,
            quantity: newQuantity,
            diameter_wise: newDiameterWise,
            unit_measurement: newUomId,
            unit_measurement_id: newUoM,
          };
        }
        return row;
      })
    );
  };

  const calculateAdjustedQuantity = (quantity, currentUoM, preferredUoM) => {
    if (currentUoM === "MT" && preferredUoM === "KG") {
      return quantity * 1000;
    } else if (currentUoM === "Bag" && preferredUoM === "KG") {
      return quantity * 50;
    } else if (currentUoM === "Bag" && preferredUoM === "MT") {
      return (quantity * 50) / 1000;
    } else if (currentUoM === "KG" && preferredUoM === "MT") {
      return quantity / 1000;
    } else if (currentUoM === "Cubic Meter" && preferredUoM === "Cubic Meter") {
      return quantity;
    }
    return quantity;
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleShowHoveredPRDetails = (prNumber, statePRDetails, creator) => {
    setPRNumberHover(prNumber);
    setCreatorHover(creator);
    setStatePRDetailsHover(statePRDetails);
    showModal();
  };

  const buildUnmergedPayload = (
    uiTableData,
    originalDataSource,
    rfq_master
  ) => {
    const siteMap = {};

    if (!originalDataSource) {
      return { rfq_master, rfq_site_details: [] };
    }

    originalDataSource.forEach((prObject) => {
      (prObject.city_wise_pr || []).forEach((city) => {
        city.site_wise_details.forEach((site) => {
          if (!siteMap[site.site_id]) {
            siteMap[site.site_id] = {
              purchase_requisition_site_name: site.site_id,
              rfq_material_details: [],
            };
          }

          site.material_wise_details.forEach((originalMaterial) => {
            const uiRow = uiTableData.find(
              (row) =>
                row.isMaterialRow &&
                row.siteId === site.site_id &&
                row.materialName === originalMaterial.material_type_name
            );

            if (uiRow) {
              const selectedVendorIds = (uiRow.vendors || [])
                .filter((v) => v.is_selected_vendor)
                .map((v) => v.id);

              let newQuantity = originalMaterial.pr_total_quantity;
              let newQuantityByKg = originalMaterial.pr_total_quantity_by_kg;

              if (uiRow.uom !== originalMaterial.material_type_uom_name) {
                if (
                  uiRow.uom === "MT" &&
                  originalMaterial.material_type_uom_name === "KG"
                ) {
                  newQuantity = originalMaterial.pr_total_quantity / 1000;
                } else if (
                  uiRow.uom === "KG" &&
                  originalMaterial.material_type_uom_name === "MT"
                ) {
                  newQuantity = originalMaterial.pr_total_quantity * 1000;
                }
              }

              let steel_size = (originalMaterial.diameter_wise || []).map(
                (dia) => {
                  let qty = dia.quantity;
                  if (originalMaterial.material_type_uom_name !== uiRow.uom) {
                    if (
                      originalMaterial.material_type_uom_name === "KG" &&
                      uiRow.uom === "MT"
                    ) {
                      qty = qty / 1000;
                    } else if (
                      originalMaterial.material_type_uom_name === "MT" &&
                      uiRow.uom === "KG"
                    ) {
                      qty = qty * 1000;
                    }
                  }
                  return {
                    diameter_id: dia.diameter_id,
                    quantity: qty,
                  };
                }
              );

              const diameterWiseAmount = (
                originalMaterial.diameter_wise || []
              ).reduce((total, dia) => {
                let quantityInKg = dia.quantity;
                if (originalMaterial.material_type_uom_name === "MT") {
                  quantityInKg = dia.quantity * 1000;
                }
                return total + quantityInKg * dia.estimated_price;
              }, 0);

              const payloadItem = {
                id: originalMaterial.rfq_material_id || null,
                material_total_quantity: newQuantity,
                material_total_quantity_by_kg: newQuantityByKg,
                amount: diameterWiseAmount,
                purchase_requisition_material:
                  originalMaterial.purchase_requisition_material_id,
                unit_of_measurement:
                  uiRow.unit_measurement || originalMaterial.material_type_uom,
                vendor: selectedVendorIds,
                steel_size,
              };
              siteMap[site.site_id].rfq_material_details.push(payloadItem);
            }
          });
        });
      });
    });

    return {
      rfq_master,
      rfq_site_details: Object.values(siteMap),
    };
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const hasEmptyVendor = tableData.some(
        (item) =>
          item.isMaterialRow &&
          (!item.vendors ||
            item.vendors.filter((v) => v.is_selected_vendor).length === 0)
      );

      if (hasEmptyVendor) {
        ErrorNotificationMsg("Select At Least One Vendor");
        setBtnLoading(false);
        return;
      }

      const payload = buildUnmergedPayload(tableData, originalData, masterId);

      let response;
      // if (rfqMaterialDetailsID === false) {
      response = await postRequest(`rfq-material-details/`, payload);
      //           } else {
      //       response = await patchRequest(
      //         `rfq-material-details/${masterId}/`,
      //     payload
      //       );
      // }

      if (response.data.success) {
        SuccessNotificationMsg(response.data.message);
        navigate(`/request-for-quotation/history`);
      } else {
        ErrorNotificationMsg(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error submitting RFQ:", error);
      ErrorNotificationMsg("An error occurred while submitting the RFQ.");
    } finally {
      setBtnLoading(false);
    }
  };

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      width: 50,
      align: "center",
      render: (text, record) => {
        if (record.isSubTotal || record.isCityTotal) {
          return null;
        }
        return text;
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      width: 150,
      align: "left",
      render: (text, record) => {
        if (record.isSubTotal) {
          return <div className="subtotal">{text}</div>;
        }
        if (record.isCityTotal) {
          return <div className="citytotal">{text}</div>;
        }
        return text;
      },
    },
    {
      title: "Sub category",
      dataIndex: "subCategory",
      width: 120,
      align: "left",
      render: (text, record) => {
        if (record.isSubTotal || record.isCityTotal) {
          return null;
        }
        return <div className="lblvalue">{text}</div>;
      },
    },
    {
      title: "Grade & Quality",
      dataIndex: "materialName",
      width: 180,
      align: "left",
      render: (text, record) => {
        if (record.isSubTotal || record.isCityTotal) {
          return null;
        }
        return <div className="lblvalue">{text}</div>;
      },
    },
    ...diameterList.map((dia) => ({
      title: dia,
      dataIndex: "diameter_wise",
      width: 80,
      align: "center",
      render: (diameter_wise, record) => {
        if (!record.isMaterialRow) return null;
        const found = diameter_wise?.find(
          (d) => d.diameter_name.replace(".00 mm", " MM") === dia
        );
        return <span>{found ? found.quantity : "-"}</span>;
      },
    })),
    {
      title: "Preferred UoM.",
      dataIndex: "unit_measurement_name",
      width: 120,
      align: "center",
      render: (text, record) => {
        if (!record.isMaterialRow) return null;
        return (
          <div style={{ textAlign: "center" }}>
            <Select
              style={{ width: "90%" }}
              value={record.uom}
              onChange={(value) => handleUOMChange(value, record.key)}
            >
              {pincodeList
                .filter((i) => i.unit_of_measurement !== "Cubic Meter")
                .map((option) => (
                  <Option key={option.id} value={option.unit_of_measurement}>
                    {option.unit_of_measurement}
                  </Option>
                ))}
            </Select>
          </div>
        );
      },
    },
    {
      title: "Qty. In Kg",
      dataIndex: "quantity_by_kg",
      width: 100,
      align: "right",
      render: (text, record) => {
        if (!record.isMaterialRow) return null;
        return (
          <div className="lblvalue" style={{ justifySelf: "end" }}>
            {text?.toLocaleString("en-IN", {
              maximumFractionDigits: 0,
            })}
          </div>
        );
      },
    },
    {
      title: "Est. Amount",
      dataIndex: "estAmount",
      align: "right",
      width: 130,
      render: (text, record) => {
        if (record.isSubTotal) {
          return (
            <div className="subtotal" style={{ justifySelf: "end" }}>
              ₹{" "}
              {record.totalAmount?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </div>
          );
        }

        if (record.isCityTotal) {
          return (
            <div className="citytotal" style={{ justifySelf: "end" }}>
              ₹{" "}
              {record.totalAmount?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </div>
          );
        }

        if (!record.isMaterialRow) return null;

        return (
          <div className="lblvalue" style={{ justifySelf: "end" }}>
            ₹{" "}
            {record.estAmount?.toLocaleString("en-IN", {
              maximumFractionDigits: 0,
            }) || ""}
          </div>
        );
      },
    },
    {
      title: (
        <span>
          Bidder(s)&nbsp;
          <Tooltip title="Eligible vendors are pre-selected. You can deselect or change them. Only selected vendors will be able to submit their proposals.">
            <InfoCircleOutlined
              style={{ color: "#ffffffff", cursor: "pointer" }}
            />
          </Tooltip>
        </span>
      ),
      dataIndex: "vendors",
      width: 350,
      render: (vendors, record) => {
        if (!record.isMaterialRow) return null;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Select
              style={{ width: "100%" }}
              mode="multiple"
              maxTagCount="responsive"
              allowClear
              showSearch
              placeholder="Please select"
              optionFilterProp="children"
              value={
                vendors?.filter((v) => v.is_selected_vendor).map((v) => v.id) ||
                []
              }
              onChange={(selectedVendorIds) =>
                handleVendorChange(selectedVendorIds, record.key)
              }
            >
              {vendors?.map((vendor) => (
                <Select.Option key={vendor.id} value={vendor.id}>
                  {vendor.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        );
      },
    },
    {
      title: "Remark",
      dataIndex: "remark",
      align: "left",
      width: 100,
      className: "no-transform-remarks",
      render: (text, record) => {
        if (
          record.siteName !== "City Total" &&
          record.siteName !== "Site Sub-Total"
        ) {
          return <span>{text ? text : " "}</span>;
        }
      },
    },
  ];

  columns.splice(1, 0, {
    title: "City",
    dataIndex: "cityName",
    key: "cityName",
    width: 160,
    onCell: (record) => {
      if (record.isSubTotal || record.isCityTotal) {
        return { colSpan: 1 };
      }
      return { rowSpan: record.cityRowSpan };
    },
    render: (text) => <div className="lblvalue">{text}</div>,
  });

  const theadPR = <Table columns={columns} />;

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Select Vendor</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {" "}
                <Link to={`/request-for-quotation/add-rfq/${responseId}`}>
                  Add RFQ
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Select Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h5
            className="rfq-number new"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            PR Number :{" "}
            {prNumberList.map((prNumber, index) => {
              return (
                <>
                  <span
                    key={index}
                    onMouseEnter={() => {
                      handleShowHoveredPRDetails(
                        prNumber?.pr_number,
                        prNumber?.data,
                        prNumber?.pr_creator
                      );
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {prNumber?.pr_number}
                    <InfoCircleOutlined
                      style={{
                        color: "#094E8F",
                        marginLeft: "3px",
                        background: "none",
                        paddingRight: "0",
                        padding: "0px",
                      }}
                    />
                  </span>
                </>
              );
            })}
          </h5>
        </div>
      </div>
      <div className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec mt-5 tablegridsec">
            <div className="PR-body tbl-collapse" style={{ padding: "0" }}>
              <Row gutter={16} style={{ marginBottom: "10px" }}>
                <Col className="TextFeild gutter-row">
                  <h5 className="rfq-number new">
                    RFQ Number : <span>{rfqNumber}</span>
                  </h5>
                </Col>
              </Row>

              {
                <>
                  {RFQMaterialDetails?.pr_city_wise_by_pr_number?.map(
                    (prObject, prIndex) => (
                      <>
                        <div className="tablewrp" style={{ padding: "0" }}>
                          <Table
                            columns={columns}
                            dataSource={tableData.filter((row) =>
                              row.key.startsWith(`${prIndex}`)
                            )}
                            scroll={{
                              x: "2200px",
                            }}
                            pagination={false}
                            rowKey="key"
                            bordered
                          />
                        </div>
                      </>
                    )
                  )}
                </>
              }
            </div>
          </section>
        </div>
        <div
          className="FormFooter bidftr"
          style={{ padding: "16px  ", margin: "0" }}
        >
          <ButtonField
            className="SaveGradiantBtn"
            type="primary"
            htmlType="Previous"
            label="Previous"
            onClick={() =>
              navigate(`/request-for-quotation/add-rfq/${responseId}`)
            }
          />
          <ButtonField
            className="SaveGradiantBtn"
            type="primary"
            htmlType="submit"
            label="Save & Send RFQ For Approval"
            onClick={() => handleSubmit(state.rfqId)}
            loading={btnLoading}
          />
        </div>
      </div>
      <Modal
        className="ModelPopupSecPopUpPRDetails"
        title={
          <div style={{ justifyItems: "center" }}>
            <h5 className="rfq-number new">
              PR Number : <span>{prNumberHover}</span>
              PR Creator : <span>{prCreatorHover}</span>
            </h5>
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={handleCancel}
        keyboard={true}
        width={"90%"}
      >
        <PRPopUpDetailsForSteel prData={statePRDetailsHover} />
      </Modal>
    </>
  );
};
export default CityWiseVendorSelection;
